import OrgTableShimmer from "ATSComponents/Common/OrgTableShimmer";
import ResumePreviewPanel from "ATSComponents/Candidates/ResumePreviewPanel";
import axios from "axios";
import { Card } from "primereact/card";
import { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import {
    FaBriefcase,
    FaClipboardCheck,
    FaExternalLinkAlt,
    FaMinus,
    FaPen,
    FaPlus,
    FaRegEye,
    FaRegStar,
    FaRegTrashAlt,
    FaSearch,
    FaTimes,
    FaUserTie
} from "react-icons/fa";
import { FiBriefcase, FiMail, FiPhone } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import {
    Button, Col, Container, Input, InputGroupText, Modal,
    ModalBody,
    ModalFooter,
    ModalHeader, Row
} from "reactstrap";
import Swal from 'sweetalert2';
import Select, { components as SelectComponents } from "react-select";

/** ===== Design tokens (kept local so this file stays drop-in) ===== */
const ui = {
    page: "#f6f7fb",
    surface: "#ffffff",
    border: "#e6e9f0",
    text: "#0f172a",
    subtext: "#64748b",
    faint: "#94a3b8",
    primary: "#4f46e5",
    primaryDark: "#4338ca",
    primarySoft: "#eef2ff",
    danger: "#e11d48",
    dangerSoft: "#fef1f4",
    radiusLg: 18,
    radiusMd: 12,
    shadow: "0 2px 10px rgba(15, 23, 42, 0.06)",
    shadowMd: "0 8px 24px rgba(15, 23, 42, 0.08)",
};

const JOB_DROPDOWN_PAGE_SIZE = 10;
const JOB_SEARCH_DEBOUNCE_MS = 400;

const CandidateDetailsView = () => {
    const { state } = useLocation();

    /** ✅ Job order dropdown state */
    const [currentJobId, setCurrentJobId] = useState(state?.job_id);
    const [currentCompanyId, setCurrentCompanyId] = useState(state?.companyId);

    /** ✅ Job dropdown: paginated + searchable options */
    const [jobOptions, setJobOptions] = useState([]);
    const [jobsLoading, setJobsLoading] = useState(false);
    const [jobDropdownPage, setJobDropdownPage] = useState(1);
    const [jobDropdownSearch, setJobDropdownSearch] = useState("");
    const [jobDropdownTotal, setJobDropdownTotal] = useState(0);
    const jobSearchTimeoutRef = useRef(null);
    const jobDropdownRequestIdRef = useRef(0);

    /** ✅ Total pages available for the job dropdown, based on page size + total count */
    const totalJobDropdownPages = Math.max(1, Math.ceil(jobDropdownTotal / JOB_DROPDOWN_PAGE_SIZE));

    const getJobIdValue = (job) => {
        const safeJob = job || {};
        return safeJob.job_id ?? safeJob.id ?? safeJob.job_order_id ?? safeJob.value ?? "";
    };
    const getJobTitleValue = (job) => {
        const safeJob = job || {};
        return safeJob.job_title || safeJob.position || safeJob.job_order_id || safeJob.label || "Job Order";
    };
    const normalizeJobOption = (job) => {
        if (!job) return null;
        const value = getJobIdValue(job);
        if (!value) return null;

        return {
            value: String(value),
            label: getJobTitleValue(job),
            job,
        };
    };

    const [candidates, setCandidates] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dataloading, setDataLoading] = useState(false);

    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectedCandidates, setSelectedCandidates] = useState([]);
    const [showDeleteCandidateModal, setShowDeleteCandidateModal] = useState(false);
    const [candidateDeleteId, setcandidateDeleteId] = useState(null);
    const [CandidateDeleteLoader, setCandidateDeleteLoader] = useState(null);
    const [candidateDetailPanel, setCandidateDetailPanel] = useState("contact");

    const sectionLabel = {
        margin: "0 0 8px",
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: "0.07em",
        textTransform: "uppercase",
        color: ui.faint,
    };

    const sectionDivider = {
        border: `1px solid ${ui.border}`,
        borderRadius: ui.radiusMd,
        padding: "14px 16px",
        marginBottom: 14,
        background: "#fbfbfe",
    };

    const formatExportDateTime = (value) => {
        if (!value) return "—";

        const parsed = new Date(value);
        if (Number.isNaN(parsed.getTime())) return value;

        const day = String(parsed.getDate()).padStart(2, "0");
        const month = String(parsed.getMonth() + 1).padStart(2, "0");
        const year = parsed.getFullYear();

        let hours = parsed.getHours();
        const minutes = String(parsed.getMinutes()).padStart(2, "0");

        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        return `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    };

    // safer experience formatter
    const formatExperience = (exp) => {
        if (!exp) return "—";

        const [yearPart, monthPart = "0"] = String(exp).split(".");
        const years = Number(yearPart) || 0;
        const months = Number(monthPart[0]) || 0;

        return `${years} ${years === 1 ? "Year" : "Years"}${months > 0 ? ` ${months} ${months === 1 ? "Month" : "Months"}` : ""
            }`;
    };

    const renderCandidateHistoryItems = (list = [], type) => {
        if (!list || list.length === 0) {
            return <span className="text-muted" style={{ fontSize: 13 }}>—</span>;
        }

        return (
            <div className="d-flex flex-column gap-2">
                {list.map((item, i) => (
                    <div
                        key={i}
                        style={{
                            padding: "10px 12px",
                            borderRadius: 10,
                            border: `1px solid ${ui.border}`,
                            background: "#fff",
                        }}
                    >
                        {/* TITLE */}
                        <div style={{ fontSize: 13, fontWeight: 700, color: ui.text }}>
                            {type === "education" && (item?.degree || "—")}
                            {type === "employment" && (item?.company_name || "—")}
                            {type === "certificates" && (item?.certificate_name || "—")}
                        </div>

                        {/* SUB TEXT */}
                        <div style={{ fontSize: 12, color: ui.subtext, marginTop: 2 }}>

                            {/* EDUCATION */}
                            {type === "education" && (
                                <>
                                    {item?.school_name || "—"}
                                    {item?.field_of_study && ` • ${item.field_of_study}`}
                                    {item?.end_year && ` • ${item.end_year}`}
                                </>
                            )}

                            {/* EMPLOYMENT */}
                            {type === "employment" && (
                                <>
                                    {item?.job_title || "—"} •{" "}
                                    {formatExportDateTime(item?.start_date)} -{" "}
                                    {item?.end_date
                                        ? formatExportDateTime(item?.end_date)
                                        : "Present"}
                                </>
                            )}

                            {/* CERTIFICATES (optional safe) */}
                            {type === "certificates" && (
                                <>
                                    {item?.issued_by || "—"}
                                    {item?.issued_date && ` • ${formatExportDateTime(item.issued_date)}`}
                                </>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        );
    };

    const handleCandidateDlink = (data) => {
        setShowDeleteCandidateModal(true);
        setcandidateDeleteId(data.job_candidate_id)
    }

    const confirmDeleteCandidate = async () => {
        setCandidateDeleteLoader(true);

        try {
            await axios.delete(`/api/v1/candidate-job-links/${candidateDeleteId}/`);

            setShowDeleteCandidateModal(false);

            Swal.fire({
                icon: "success",
                title: "Deleted!",
                text: "Candidate deleted successfully.",
                confirmButtonText: "OK",
            });

            // Refresh table
            getCandidateDetails(currentPage, perPage, localSearch);

        } catch (error) {
            console.error("Delete candidate failed", error);

            const apiErrorMessage =
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                "Failed to delete candidate. Please try again.";

            setShowDeleteCandidateModal(false);

            Swal.fire({
                icon: "error",
                title: "Deletion Failed",
                text: apiErrorMessage,
                confirmButtonText: "OK",
            });

        } finally {
            setCandidateDeleteLoader(false);
        }
    };

    const CustomLoader = () => (
        <div className='text-center py-4'>
            <div className='spinner-border' role='status' style={{ color: ui.primary }}>
                <span className='sr-only'>Loading...</span>
            </div>
        </div>
    );

    /** ✅ search state */
    const [localSearch, setLocalSearch] = useState("");

    /** ✅ Build clean params */
    const buildParams = (paramsObj) => {
        const clean = {};
        for (let key in paramsObj) {
            if (paramsObj[key] !== "" && paramsObj[key] !== undefined && paramsObj[key] !== null) {
                clean[key] = paramsObj[key];
            }
        }
        return clean;
    };

    const [companyName, setCompanyName] = useState("");
    const [jobName, setJobName] = useState("");
    const [designation, setDesignation] = useState("");
    const [minExperience, setMinExperience] = useState(null);
    const [maxExperience, setMaxExperience] = useState(null);

    /**
     * ✅ Fetch a page of job orders for the dropdown (paginated + searchable).
     * page/search let us page through results and filter by typed text.
     * Always replaces the option list — no infinite-scroll / append mode.
     */
    const fetchJobOptions = async (page = 1, search = "") => {
        const requestId = ++jobDropdownRequestIdRef.current;
        setJobsLoading(true);
        try {
            const companyId = currentCompanyId || state?.companyId;
            const params = buildParams({
                page,
                size: JOB_DROPDOWN_PAGE_SIZE,
                search,
                company_id: companyId,
            });
            const res = await axios.get(`/api/v1/create-job-order/`, { params });

            // ✅ ignore stale responses (e.g. a fast second keystroke resolving before the first)
            if (requestId !== jobDropdownRequestIdRef.current) return;

            const jobs = res?.data?.results || [];
            const total = res?.data?.count ?? jobs.length;
            const options = jobs
                .map((job) => normalizeJobOption(job))
                .filter(Boolean);

            setJobOptions(options);
            setJobDropdownTotal(total);
            setJobDropdownPage(page);
        } catch (error) {
            console.error("Failed to fetch job options", error);
            setJobOptions([]);
        } finally {
            if (requestId === jobDropdownRequestIdRef.current) {
                setJobsLoading(false);
            }
        }
    };

    /** ✅ Go to the previous page of job options */
    const handleJobDropdownPrevPage = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (jobsLoading || jobDropdownPage <= 1) return;
        fetchJobOptions(jobDropdownPage - 1, jobDropdownSearch);
    };

    /** ✅ Go to the next page of job options */
    const handleJobDropdownNextPage = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (jobsLoading || jobDropdownPage >= totalJobDropdownPages) return;
        fetchJobOptions(jobDropdownPage + 1, jobDropdownSearch);
    };

    /** ✅ Custom menu list: renders a Prev/Next pagination footer so users can jump between pages directly (no scroll-to-load-more). */
    const JobDropdownMenuList = (menuListProps) => (
        <SelectComponents.MenuList {...menuListProps}>
            {menuListProps.children}

            {/* ✅ Prev / Next pagination footer */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 8,
                    padding: "8px 10px",
                    borderTop: `1px solid ${ui.border}`,
                    background: "#fbfbfe",
                    position: "sticky",
                    bottom: 0,
                }}
                onMouseDown={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                }}
            >
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    disabled={jobsLoading || jobDropdownPage <= 1}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    onClick={handleJobDropdownPrevPage}
                    style={{ fontSize: 12 }}
                >
                    ‹ Prev
                </button>
                <span style={{ fontSize: 11, color: ui.subtext, whiteSpace: "nowrap" }}>
                    {jobsLoading ? "Loading..." : `Page ${jobDropdownPage} / ${totalJobDropdownPages}`}
                </span>
                <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary"
                    disabled={jobsLoading || jobDropdownPage >= totalJobDropdownPages}
                    onMouseDown={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                    }}
                    onClick={handleJobDropdownNextPage}
                    style={{ fontSize: 12 }}
                >
                    Next ›
                </button>
            </div>
        </SelectComponents.MenuList>
    );

    /** ✅ Debounced search-as-you-type inside the job dropdown */
    const handleJobDropdownInputChange = (value, meta) => {
        // react-select also fires this on blur/menu-close/set-value; only react to real typing
        if (meta.action !== "input-change") return value;

        setJobDropdownSearch(value);

        if (jobSearchTimeoutRef.current) {
            clearTimeout(jobSearchTimeoutRef.current);
        }
        jobSearchTimeoutRef.current = setTimeout(() => {
            fetchJobOptions(1, value);
        }, JOB_SEARCH_DEBOUNCE_MS);

        return value;
    };

    /** ✅ Load the first page the first time the dropdown is opened */
    const handleJobDropdownMenuOpen = () => {
        if (jobOptions.length === 0 && !jobsLoading) {
            fetchJobOptions(1, jobDropdownSearch);
        }
    };

    /** ✅ Handle switching the selected job order */
    const handleJobOrderChange = async (option) => {
        const nextJobId = option?.value;
        if (!nextJobId || nextJobId === currentJobId) return;

        const selectedJob = option?.job;
        const nextCompanyId = selectedJob?.company_id ?? selectedJob?.company?.id ?? currentCompanyId;

        setCurrentJobId(nextJobId);
        setCurrentCompanyId(nextCompanyId);
        setCurrentPage(1);
        setLocalSearch("");

        await getCandidateDetails(1, perPage, "", nextJobId, nextCompanyId);
    };

    /** ✅ Fetch candidates with pagination + search */
    const getCandidateDetails = async (page = 1, size = perPage, search = "", jobIdParam = currentJobId, companyIdParam = currentCompanyId) => {
        setDataLoading(true);

        const params = buildParams({
            job_id: jobIdParam,
            page,
            size,
            company_id: companyIdParam,
            search: search,
        });

        try {
            const res = await axios.get(`/api/v1/candidates/candidates-by-job/`, { params });

            const result = res?.data?.results?.candidates || [];
            const results = res?.data?.results;
            setCompanyName(results?.company_name || "-");
            setDesignation(results?.designation || "-");
            setMinExperience(results?.min_experience);
            setMaxExperience(results?.max_experience);
            setJobName(results?.job_name)
            setCandidates(result);

            // ✅ if backend doesn’t send total, fallback to count
            setTotalRows(res?.data?.count ?? result.length);
        } catch (error) {
            console.log("Error fetching candidates", error);
        } finally {
            setDataLoading(false);
            setLoading(false);
        }
    };

    /** ✅ Initial load */
    useEffect(() => {
        getCandidateDetails(1);
        fetchJobOptions(1, "");
    }, []);

    /** ✅ Clean up any pending debounce timer on unmount */
    useEffect(() => {
        return () => {
            if (jobSearchTimeoutRef.current) {
                clearTimeout(jobSearchTimeoutRef.current);
            }
        };
    }, []);

    /** ✅ Search handler */
    const handleCandidateSearch = () => {
        setCurrentPage(1);
        getCandidateDetails(1, perPage, localSearch);
    };

    /** ✅ Pagination handlers with search support */
    const handlePageChange = async (page) => {
        setCurrentPage(page);
        getCandidateDetails(page, perPage, localSearch);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setCurrentPage(1);

        if (newPerPage === -1) {
            setPerPage(totalRows);
            getCandidateDetails(1, totalRows, localSearch);
        } else {
            setPerPage(newPerPage);
            getCandidateDetails(1, newPerPage, localSearch);
        }
    };

    /** ✅ Expand Talent Scan Table */
    const ExpandComponent = ({ data }) => {
        const scans = data?.talent_scan_result?.results || [];

        if (scans.length === 0) {
            return <p className="p-3 text-muted mb-0">No Talent Scan Assigned.</p>;
        }

        const columns = [
            { name: "Test Name", selector: r => r.test_info?.name || "-" },
            { name: "Email", selector: r => r.test_email },
            { name: "Score", selector: r => `${r.total_candidate_score}/${r.total_test_score}` },
            { name: "Attempted", selector: r => r.is_attempted ? "Yes" : "No" },
            {
                name: "Open",
                cell: r => (
                    <a
                        href={r.link}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            fontSize: 12,
                            fontWeight: 600,
                            color: ui.primary,
                            background: ui.primarySoft,
                            padding: "5px 10px",
                            borderRadius: 8,
                            textDecoration: "none",
                        }}
                    >
                        Open <FaExternalLinkAlt size={10} />
                    </a>
                )
            }
        ];

        return (
            <div style={{ padding: "14px 18px", background: "#fbfbfe" }}>
                <h6 className="mb-2" style={{ fontWeight: 700, color: ui.text }}>Talent Scan Details</h6>
                <div id="TalentScanResultView">
                    <DataTable data={scans} columns={columns} dense highlightOnHover />
                </div>
            </div>
        );
    };

    /** ✅ Main columns */
    const columns = [
        {
            name: "Name",
            sortable: true,
            cell: (row, index) => {
                const fullName = [row.first_name, row.middle_name, row.last_name].filter(Boolean).join(" ");
                return (
                    <span
                        onClick={() => handleViewCandidate(row, index)}
                        title={fullName ? `${fullName} — view profile & resume` : "View profile & resume"}
                        style={{
                            color: ui.primary,
                            fontWeight: 600,
                            cursor: "pointer",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            maxWidth: "100%",
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.textDecoration = "underline")}
                        onMouseLeave={(e) => (e.currentTarget.style.textDecoration = "none")}
                    >
                        {fullName || "—"}
                    </span>
                );
            },
        },
        {
            name: "Email",
            width: "300px",
            cell: row => (
                <span title={row.email} style={{ color: ui.subtext }}>
                    {row.email}
                </span>
            ),
        },
        {
            name: "Phone",
            cell: row => (
                <span title={row.mobile_phone} style={{ color: ui.subtext }}>
                    {row.mobile_phone}
                </span>
            ),
        },
        {
            name: "Experience",
            cell: row => {
                const exp = row?.total_experience;

                if (!exp) return <span className="text-muted">—</span>;

                const [yearPart, monthPart = "0"] = String(exp).split(".");
                const years = Number(yearPart) || 0;
                const months = Number(monthPart[0]) || 0;

                return (
                    <span
                        title={`${years} Year(s) ${months ? months + " Month(s)" : ""}`}
                        style={{
                            fontSize: 12,
                            fontWeight: 600,
                            color: "#0369a1",
                            background: "#e0f2fe",
                            border: "1px solid #bae6fd",
                            padding: "4px 10px",
                            borderRadius: 999,
                            display: "inline-block",
                        }}
                    >
                        {years} {years === 1 ? "Year" : "Years"}
                        {months > 0 && ` ${months} ${months === 1 ? "Month" : "Months"}`}
                    </span>
                );
            }
        },
        {
            name: "Assigned Tests",
            cell: (row) => {
                const assignedTests = row?.talent_scan_result?.results || [];
                const has = assignedTests.length > 0;
                return (
                    <button
                        onClick={() => handleViewAssignedTests(row)}
                        title="View Assigned Tests"
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 6,
                            fontSize: 12,
                            fontWeight: 600,
                            color: has ? "#7c3aed" : ui.subtext,
                            background: has ? "#f3e8ff" : "#f1f5f9",
                            border: `1px solid ${has ? "#e9d5ff" : "#e2e8f0"}`,
                            padding: "6px 12px",
                            borderRadius: 999,
                            cursor: "pointer",
                        }}
                    >
                        <FaClipboardCheck size={12} />
                        {has ? `${assignedTests.length} Test${assignedTests.length > 1 ? "s" : ""}` : "No Tests"}
                    </button>
                );
            }
        },
        {
            name: "Action",
            cell: (row, index) => (
                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                    <button
                        onClick={() => handleViewCandidate(row, index)}
                        title="View Candidate Details"
                        style={{
                            width: 32,
                            height: 32,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 8,
                            border: `1px solid ${ui.border}`,
                            background: "#fff",
                            color: ui.primary,
                            cursor: "pointer",
                        }}
                    >
                        <FaRegEye size={14} />
                    </button>
                    <button
                        onClick={() => handleCandidateDlink(row)}
                        title="Delete Candidate"
                        style={{
                            width: 32,
                            height: 32,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 8,
                            border: `1px solid ${ui.dangerSoft}`,
                            background: ui.dangerSoft,
                            color: ui.danger,
                            cursor: "pointer",
                        }}
                    >
                        <FaRegTrashAlt size={13} />
                    </button>
                </div>
            )
        }
    ];

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };

    /** ✅ Polished styling for react-data-table-component */
    const dataTableCustomStyles = {
        headRow: {
            style: {
                backgroundColor: "#f8fafc",
                borderBottom: `1px solid ${ui.border}`,
                minHeight: "46px",
            },
        },
        headCells: {
            style: {
                fontSize: "11px",
                fontWeight: 800,
                letterSpacing: "0.05em",
                textTransform: "uppercase",
                color: ui.subtext,
            },
        },
        rows: {
            style: {
                minHeight: "56px",
                fontSize: "13.5px",
                color: ui.text,
                "&:hover": {
                    backgroundColor: "#fafafe",
                },
            },
        },
        pagination: {
            style: {
                borderTop: `1px solid ${ui.border}`,
            },
        },
    };

    const navigate = useNavigate()
    const [viewCandidateModal, setViewCandidateModal] = useState(false);
    const [selectedCandidate, setSelectedCandidate] = useState(null);
    const [viewCandidateIndex, setViewCandidateIndex] = useState(null);

    // SAFE NORMALIZATION (handles different API formats)
    const selectedEducationHistory =
        selectedCandidate?.education ||
        selectedCandidate?.education_history ||
        [];

    const selectedEmploymentHistory =
        selectedCandidate?.employment ||
        selectedCandidate?.employment_history ||
        [];

    const selectedCertificateHistory =
        selectedCandidate?.certificates ||
        selectedCandidate?.certificate_history ||
        [];

    const selectedPrimarySkills =
        selectedCandidate?.primary_skills || [];

    const selectedSecondarySkills =
        selectedCandidate?.secondary_skills || [];

    const selectedOtherSkills =
        selectedCandidate?.other_skills || [];

    const handleViewCandidate = (candidate, index) => {
        setSelectedCandidate(candidate);
        setViewCandidateIndex(index);
        setViewCandidateModal(true);
    };

    /** ✅ Move to the previous / next candidate in the currently loaded page */
    const handlePrevCandidate = () => {
        if (viewCandidateIndex === null) return;
        const prevIndex = viewCandidateIndex - 1;
        if (prevIndex >= 0) {
            setSelectedCandidate(candidates[prevIndex]);
            setViewCandidateIndex(prevIndex);
        }
    };

    const handleNextCandidate = () => {
        if (viewCandidateIndex === null) return;
        const nextIndex = viewCandidateIndex + 1;
        if (nextIndex < candidates.length) {
            setSelectedCandidate(candidates[nextIndex]);
            setViewCandidateIndex(nextIndex);
        }
    };

    const skillColors = {
        blue: { bg: "#E6F1FB", color: "#0C447C", border: "#B5D4F4" },
        teal: { bg: "#E1F5EE", color: "#085041", border: "#9FE1CB" },
        gray: { bg: "#F1EFE8", color: "#444441", border: "#D3D1C7" },
    };

    const SkillPill = ({ label, color = "gray" }) => {
        const c = skillColors[color];
        return (
            <span style={{
                fontSize: 13, padding: "4px 12px", borderRadius: 999, fontWeight: 500,
                background: c.bg, color: c.color, border: `1px solid ${c.border}`,
            }}>
                {label}
            </span>
        );
    };

    const handleViewAssignedTests = (candidate) => {
        setSelectedAssignedTests(candidate?.talent_scan_result?.results || []);
        setViewAssignedTestsModal(true);
    };
    const [viewAssignedTestsModal, setViewAssignedTestsModal] = useState(false);
    const [selectedAssignedTests, setSelectedAssignedTests] = useState(null);

    /** ✅ Currently selected job option shown in the dropdown */
    const selectedJobOption =
        jobOptions.find((option) => option.value === String(currentJobId)) ||
        (jobName ? { value: String(currentJobId), label: jobName } : null);

    /** ✅ Reusable summary tile for the top KPI row */
    const SummaryCard = ({ icon: Icon, gradient, label, value }) => (
        <Card
            className="border-0"
            style={{
                borderRadius: ui.radiusLg,
                boxShadow: ui.shadow,
                marginBottom: 16,
            }}
        >
            <div className="d-flex align-items-center" style={{ padding: "16px 18px", gap: 14 }}>
                <div
                    style={{
                        width: 52,
                        height: 52,
                        borderRadius: 14,
                        background: gradient,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        boxShadow: "0 8px 16px rgba(15,23,42,0.14)",
                    }}
                >
                    <Icon className="text-white" style={{ fontSize: "1.4rem" }} />
                </div>
                <div style={{ minWidth: 0 }}>
                    <div style={{ fontSize: 11, fontWeight: 800, letterSpacing: "0.06em", textTransform: "uppercase", color: ui.faint }}>
                        {label}
                    </div>
                    <h1
                        title={typeof value === "string" ? value : undefined}
                        style={{
                            fontSize: "1.05rem",
                            fontWeight: 700,
                            color: ui.text,
                            margin: "2px 0 0",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {value}
                    </h1>
                </div>
            </div>
        </Card>
    );

    return (
        <div className="page-content allact-tabs manager-dash" style={{ background: ui.page, minHeight: "100%" }}>
            <Container fluid>
                <div className="page-title-box mb-0 recruiter-dashboard actjobsum">
                    <Col className="d-flex justify-content-between align-items-center flex-wrap" style={{ gap: 12 }}>
                        <h1 className="page-title mb-0" style={{ fontWeight: 800, color: ui.text }}>Candidate list</h1>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <div
                                style={{ minWidth: "260px" }}
                                onClick={(event) => event.stopPropagation()}
                                onMouseDown={(event) => event.stopPropagation()}
                            >
                                <Select
                                    classNamePrefix="job-order-tab-select"
                                    value={selectedJobOption}
                                    options={jobOptions}
                                    onChange={handleJobOrderChange}
                                    onMenuOpen={handleJobDropdownMenuOpen}
                                    onInputChange={handleJobDropdownInputChange}
                                    components={{ MenuList: JobDropdownMenuList }}
                                    filterOption={() => true}
                                    isLoading={jobsLoading}
                                    isSearchable
                                    placeholder="Select Job Order"
                                    loadingMessage={() => "Loading job orders..."}
                                    noOptionsMessage={() => (jobsLoading ? "Loading..." : "No job orders found")}
                                    menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                                    menuPosition="fixed"
                                    styles={{
                                        control: (base, stateProps) => ({
                                            ...base,
                                            minHeight: "40px",
                                            borderRadius: 10,
                                            borderColor: stateProps.isFocused ? ui.primary : ui.border,
                                            boxShadow: stateProps.isFocused ? `0 0 0 3px ${ui.primarySoft}` : "none",
                                            cursor: "pointer",
                                        }),
                                        valueContainer: (base) => ({
                                            ...base,
                                            padding: "0 10px",
                                            fontSize: "13px",
                                            fontWeight: 600,
                                            color: ui.text,
                                        }),
                                        indicatorsContainer: (base) => ({
                                            ...base,
                                            height: "38px",
                                        }),
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        menu: (base) => ({ ...base, borderRadius: 12, overflow: "hidden", boxShadow: ui.shadowMd }),
                                    }}
                                />
                            </div>
                            <Button
                                onClick={() => navigate(-1)}
                                className="import-res-btn"
                                style={{
                                    background: ui.primary,
                                    border: "none",
                                    borderRadius: 10,
                                    fontWeight: 600,
                                    padding: "8px 18px",
                                }}
                            >
                                Back
                            </Button>
                        </div>
                    </Col>

                    {/* ✅ Summary Cards */}
                    <Row className="mt-3">
                        <Col xxl={3} md={6}>
                            <SummaryCard
                                icon={FaBriefcase}
                                gradient="linear-gradient(135deg, #fb7185, #e11d48)"
                                label="Job Order Name"
                                value={jobName || "-"}
                            />
                        </Col>

                        <Col xxl={3} md={6}>
                            <SummaryCard
                                icon={FaUserTie}
                                gradient="linear-gradient(135deg, #34d399, #059669)"
                                label="Company"
                                value={companyName || "-"}
                            />
                        </Col>

                        <Col xxl={3} md={6}>
                            <SummaryCard
                                icon={FaPen}
                                gradient="linear-gradient(135deg, #fbbf24, #f59e0b)"
                                label="Designation"
                                value={designation || "-"}
                            />
                        </Col>

                        <Col xxl={3} md={6}>
                            <SummaryCard
                                icon={FaRegStar}
                                gradient="linear-gradient(135deg, #a78bfa, #7c3aed)"
                                label="Min-Max Exp"
                                value={`${minExperience ?? "-"} - ${maxExperience ?? "-"}`}
                            />
                        </Col>
                    </Row>

                    {/* ✅ Candidate Table + Search */}
                    <Card
                        className="border-0 p-3 mt-2"
                        style={{ borderRadius: ui.radiusLg, boxShadow: ui.shadow }}
                    >
                        <Row className="mb-3 justify-content-end">
                            <Col xxl={4}>
                                <div className="d-flex align-items-center">
                                    <div style={{ position: "relative", flex: 1 }}>
                                        <FaSearch
                                            size={13}
                                            style={{
                                                position: "absolute",
                                                left: 14,
                                                top: "50%",
                                                transform: "translateY(-50%)",
                                                color: ui.faint,
                                            }}
                                        />
                                        <Input
                                            placeholder="Search with Name and Email"
                                            value={localSearch}
                                            onChange={e => {
                                                const value = e.target.value;
                                                setLocalSearch(value)
                                                if (value === "") {
                                                    getCandidateDetails();
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") handleCandidateSearch();
                                            }}
                                            autoComplete="off"
                                            style={{
                                                borderRadius: 10,
                                                paddingLeft: 36,
                                                paddingRight: localSearch ? 36 : 12,
                                                border: `1px solid ${ui.border}`,
                                                height: 40,
                                            }}
                                        />
                                        {localSearch !== "" && (
                                            <InputGroupText
                                                style={{
                                                    position: "absolute",
                                                    right: 6,
                                                    top: "50%",
                                                    transform: "translateY(-50%)",
                                                    cursor: "pointer",
                                                    background: "transparent",
                                                    border: "none",
                                                    padding: "6px",
                                                }}
                                                onClick={() => {
                                                    setLocalSearch("");
                                                    getCandidateDetails();
                                                }}
                                            >
                                                <FaTimes style={{ fontSize: "13px", color: ui.faint }} />
                                            </InputGroupText>
                                        )}
                                    </div>

                                    <Button
                                        className="searchIconBtn import-res-btn"
                                        onClick={handleCandidateSearch}
                                        style={{
                                            marginLeft: 10,
                                            background: ui.primary,
                                            border: "none",
                                            borderRadius: 10,
                                            height: 40,
                                            width: 40,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            flexShrink: 0,
                                        }}
                                    >
                                        <FaSearch size={13} />
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                        <div id="CandidateViewSummaryTable" style={{ borderRadius: 14, overflow: "hidden", border: `1px solid ${ui.border}` }}>
                            <DataTable
                                data={candidates}
                                columns={columns}
                                progressPending={dataloading}
                                expandableRows
                                expandableRowsComponent={ExpandComponent}
                                highlightOnHover
                                pagination
                                paginationServer
                                paginationTotalRows={totalRows}
                                paginationDefaultPage={currentPage}
                                onChangePage={handlePageChange}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onSelectedRowsChange={(state) => setSelectedCandidates(state.selectedRows || [])}
                                expandableIcon={{
                                    collapsed: <span className='expander-bubble'><FaPlus /></span>,
                                    expanded: <span className='expander-bubble'><FaMinus /></span>,
                                }}
                                fixedHeader
                                fixedHeaderScrollHeight='450px'
                                persistTableHead
                                progressComponent={<OrgTableShimmer columns={6} rows={6} titleWidth="210px" />}
                                paginationComponentOptions={paginationComponentOptions}
                                customStyles={dataTableCustomStyles}
                            />
                        </div>
                    </Card>
                </div>
            </Container>

            {/* DELETE CONFIRM MODAL */}
            <Modal
                isOpen={showDeleteCandidateModal}
                toggle={() => setShowDeleteCandidateModal(!showDeleteCandidateModal)}
                centered
                contentClassName="border-0"
                style={{ borderRadius: 16 }}
            >
                <ModalHeader
                    toggle={() => setShowDeleteCandidateModal(!showDeleteCandidateModal)}
                    style={{ border: "none", paddingBottom: 0 }}
                >
                    <span style={{ fontWeight: 700, color: ui.text }}>Confirm Delete</span>
                </ModalHeader>
                <ModalBody>
                    <div
                        style={{
                            background: ui.dangerSoft,
                            border: `1px solid #fecdd3`,
                            borderRadius: 12,
                            padding: "14px 16px",
                            color: "#9f1239",
                            fontSize: 14,
                        }}
                    >
                        Are you sure you want to delete this candidate? This action cannot be undone.
                    </div>
                </ModalBody>
                <ModalFooter className="justify-content-end" style={{ border: "none" }}>
                    <Button
                        onClick={() => setShowDeleteCandidateModal(false)}
                        style={{ background: "#fff", color: ui.text, border: `1px solid ${ui.border}`, borderRadius: 10 }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={confirmDeleteCandidate}
                        disabled={CandidateDeleteLoader}
                        style={{ background: ui.danger, border: "none", borderRadius: 10 }}
                    >
                        {CandidateDeleteLoader ? "Deleting.." : "Delete"}
                    </Button>
                </ModalFooter>
            </Modal>

            {/* VIEW CANDIDATE MODAL (opens from name click or eye icon) */}
            <Modal
                isOpen={viewCandidateModal}
                toggle={() => setViewCandidateModal(false)}
                size="xl"
                centered
                className="candidate-modal"
                contentClassName="border-0"
                style={{ maxWidth: "96vw", width: "96vw" }}
            >
                {/* HEADER */}
                <ModalHeader
                    toggle={() => setViewCandidateModal(false)}
                    style={{
                        border: "none",
                        paddingBottom: 12,
                        background: "linear-gradient(135deg, #eef2ff, #f5f3ff)",
                        borderRadius: "0.3rem 0.3rem 0 0",
                    }}
                >
                    <div className="d-flex align-items-center gap-3">
                        <div
                            style={{
                                width: 48,
                                height: 48,
                                borderRadius: "50%",
                                background: "linear-gradient(135deg, #6366f1, #7c3aed)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: 700,
                                color: "#fff",
                                boxShadow: "0 6px 14px rgba(99,102,241,0.35)",
                            }}
                        >
                            {selectedCandidate?.first_name?.[0]}
                            {selectedCandidate?.last_name?.[0]}
                        </div>

                        <div>
                            <h5 className="mb-0" style={{ fontWeight: 700, color: ui.text }}>
                                {selectedCandidate?.first_name} {selectedCandidate?.middle_name || ""}{" "}
                                {selectedCandidate?.last_name}
                            </h5>

                            <small style={{ color: ui.subtext }}>
                                {selectedCandidate?.current_company || "—"} ·{" "}
                                {selectedCandidate?.total_experience || 0} Years Experience
                            </small>
                        </div>
                    </div>
                </ModalHeader>

                {/* BODY */}
                <ModalBody className="p-0 d-flex flex-column" style={{ flex: 1 }}>
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "0.65fr 1.85fr",
                            height: "100%",
                        }}
                    >

                        {/* LEFT PANEL */}
                        <div className="ats-candidate-detail-side" style={{ borderRight: `1px solid ${ui.border}` }}>

                            {/* TABS */}
                            <div
                                className="ats-candidate-detail-switch"
                                style={{
                                    display: "flex",
                                    gap: 6,
                                    padding: 14,
                                    background: "#f1f5f9",
                                    margin: 14,
                                    borderRadius: 10,
                                }}
                            >
                                <button
                                    className={candidateDetailPanel === "contact" ? "active" : ""}
                                    onClick={() => setCandidateDetailPanel("contact")}
                                    style={{
                                        flex: 1,
                                        border: "none",
                                        borderRadius: 8,
                                        padding: "8px 10px",
                                        fontSize: 13,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        background: candidateDetailPanel === "contact" ? "#fff" : "transparent",
                                        color: candidateDetailPanel === "contact" ? ui.primary : ui.subtext,
                                        boxShadow: candidateDetailPanel === "contact" ? ui.shadow : "none",
                                    }}
                                >
                                    Contact & History
                                </button>

                                <button
                                    className={candidateDetailPanel === "skills" ? "active" : ""}
                                    onClick={() => setCandidateDetailPanel("skills")}
                                    style={{
                                        flex: 1,
                                        border: "none",
                                        borderRadius: 8,
                                        padding: "8px 10px",
                                        fontSize: 13,
                                        fontWeight: 600,
                                        cursor: "pointer",
                                        background: candidateDetailPanel === "skills" ? "#fff" : "transparent",
                                        color: candidateDetailPanel === "skills" ? ui.primary : ui.subtext,
                                        boxShadow: candidateDetailPanel === "skills" ? ui.shadow : "none",
                                    }}
                                >
                                    Skills
                                </button>
                            </div>

                            <div className="ats-candidate-detail-content" style={{ padding: "0 18px 18px" }}>
                                {/* Contact */}
                                {candidateDetailPanel === "contact" && (
                                    <section style={sectionDivider}>
                                        <p style={sectionLabel}>Contact</p>

                                        <div className="d-flex flex-column gap-2">
                                            {[
                                                { Icon: FiMail, val: selectedCandidate?.email },
                                                { Icon: FiPhone, val: selectedCandidate?.mobile_phone },
                                                {
                                                    Icon: FiBriefcase,
                                                    val: `${selectedCandidate?.total_experience || 0} Years Total Experience`,
                                                },
                                            ].map(({ Icon, val }, index) => (
                                                <div key={index} className="d-flex align-items-center gap-2">
                                                    <Icon size={16} style={{ color: ui.primary }} />
                                                    <span style={{ color: ui.text, fontSize: 13.5 }}>{val || "—"}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </section>
                                )}

                                {/* Skills */}
                                {candidateDetailPanel === "skills" && (
                                    <>
                                        <section style={sectionDivider}>
                                            <p style={sectionLabel}>Primary skills</p>
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedPrimarySkills.length > 0
                                                    ? selectedPrimarySkills.map((s, i) => (
                                                        <SkillPill key={i} label={s} color="blue" />
                                                    ))
                                                    : "—"}
                                            </div>
                                        </section>

                                        <section style={sectionDivider}>
                                            <p style={sectionLabel}>Secondary skills</p>
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedSecondarySkills.length > 0
                                                    ? selectedSecondarySkills.map((s, i) => (
                                                        <SkillPill key={i} label={s} color="teal" />
                                                    ))
                                                    : "—"}
                                            </div>
                                        </section>

                                        <section style={sectionDivider}>
                                            <p style={sectionLabel}>Other skills</p>
                                            <div className="d-flex flex-wrap gap-2">
                                                {selectedOtherSkills.length > 0
                                                    ? selectedOtherSkills.map((s, i) => (
                                                        <SkillPill key={i} label={s} color="gray" />
                                                    ))
                                                    : "—"}
                                            </div>
                                        </section>
                                    </>
                                )}

                                {/* History */}
                                {candidateDetailPanel === "contact" && (
                                    <>
                                        <section style={sectionDivider}>
                                            <p style={sectionLabel}>Education</p>
                                            {renderCandidateHistoryItems(selectedEducationHistory, "education")}
                                        </section>

                                        <section style={sectionDivider}>
                                            <p style={sectionLabel}>Employment</p>
                                            {renderCandidateHistoryItems(selectedEmploymentHistory, "employment")}
                                        </section>

                                        <section style={{ ...sectionDivider, marginBottom: 0 }}>
                                            <p style={sectionLabel}>Certificates</p>
                                            {renderCandidateHistoryItems(
                                                selectedCertificateHistory,
                                                "certificates"
                                            )}
                                        </section>
                                    </>
                                )}
                            </div>
                        </div>

                        {/* RIGHT PANEL — resume preview (also opens when the candidate name is clicked) */}
                        <ResumePreviewPanel resumeUrl={selectedCandidate?.resume} />
                    </div>
                </ModalBody>

                {/* FOOTER — prev / next like the ATS candidate page */}
                <ModalFooter className="justify-content-center" style={{ border: "none", gap: 10 }}>
                    <Button
                        onClick={handlePrevCandidate}
                        disabled={viewCandidateIndex === null || viewCandidateIndex <= 0}
                        style={{ background: "#fff", color: ui.text, border: `1px solid ${ui.border}`, borderRadius: 10 }}
                    >
                        &laquo; Previous
                    </Button>
                    <Button
                        onClick={() => setViewCandidateModal(false)}
                        style={{ background: ui.primary, border: "none", borderRadius: 10 }}
                    >
                        Close
                    </Button>
                    <Button
                        onClick={handleNextCandidate}
                        disabled={viewCandidateIndex === null || viewCandidateIndex >= candidates.length - 1}
                        style={{ background: "#fff", color: ui.text, border: `1px solid ${ui.border}`, borderRadius: 10 }}
                    >
                        Next &raquo;
                    </Button>
                </ModalFooter>
            </Modal>

            {/* ASSIGNED TESTS MODAL */}
            <Modal
                isOpen={viewAssignedTestsModal}
                toggle={() => setViewAssignedTestsModal(false)}
                size="xl"
                className="candidate-modal"
                contentClassName="border-0"
            >
                <ModalHeader
                    toggle={() => setViewAssignedTestsModal(false)}
                    style={{ background: "#f8fafc", border: "none" }}
                >
                    <h4 className="mb-0" style={{ fontWeight: 700, color: ui.text }}>Assigned Tests</h4>
                </ModalHeader>

                <ModalBody
                    style={{
                        maxHeight: "75vh",
                        overflowY: "auto",
                        padding: "1.2rem",
                        backgroundColor: "#f8f9fa",
                    }}
                >
                    <Row className="g-3">
                        {selectedAssignedTests?.length ? (
                            selectedAssignedTests.map((test, i) => (
                                <Col md={12} key={i}>
                                    <div
                                        style={{
                                            border: `1px solid ${ui.border}`,
                                            borderRadius: 12,
                                            padding: "12px 16px",
                                            backgroundColor: "#fff",
                                            boxShadow: ui.shadow,
                                        }}
                                    >
                                        <div style={{ fontWeight: 700, color: ui.text, fontSize: 14 }}>
                                            {test.test_info.name}
                                        </div>
                                        <div style={{ fontSize: 13, color: ui.subtext, marginTop: 4 }}>
                                            {test.test_email}
                                        </div>
                                        <div style={{ fontSize: 13, marginTop: 4 }}>
                                            <span
                                                style={{
                                                    fontWeight: 700,
                                                    color: "#16a34a",
                                                    background: "#f0fdf4",
                                                    border: "1px solid #bbf7d0",
                                                    borderRadius: 8,
                                                    padding: "3px 10px",
                                                }}
                                            >
                                                {test.total_candidate_score}/{test.total_test_score}
                                            </span>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        ) : (
                            <Col md={12}>
                                <div style={{ color: ui.subtext, textAlign: "center", padding: "2rem" }}>
                                    No Talent Scan Test Assigned
                                </div>
                            </Col>
                        )}
                    </Row>
                </ModalBody>

                <ModalFooter className="justify-content-center" style={{ border: "none" }}>
                    <Button
                        onClick={() => setViewAssignedTestsModal(false)}
                        style={{ background: ui.primary, border: "none", borderRadius: 10, padding: "8px 24px" }}
                    >
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default CandidateDetailsView;
